import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * AdminRoute - A component that restricts access to admin-only routes
 * If the user is authenticated and is an admin, renders the child component
 * Otherwise, redirects to the login page or unauthorized page
 */
const AdminRoute = ({ children }) => {
  const { user, isAuthenticated } = useSelector(state => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user || user.role !== 'admin') {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default AdminRoute;
